import React, {Suspense} from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import useCapitalTerms from '@di-shared/features/capital/useCapitalTerms';
import useCcWebviewUtilsHelper from '@di-shared/features/common/useCcWebviewUtilsHelper';

export interface CapitalTermsDetailProps {
  termsId: string;
}

function CapitalTermsDetail({termsId}: CapitalTermsDetailProps) {
  return (
    <Suspense fallback={<Loading />}>
      <Inner termsId={termsId} />
    </Suspense>
  );
}

function Inner({termsId}: CapitalTermsDetailProps) {
  const {t} = useInferableTranslation();
  const {backOrClose} = useCcWebviewUtilsHelper();
  const {getTermsDetail} = useCapitalTerms();
  const terms = getTermsDetail(termsId);

  if (!terms) {
    backOrClose();
    return null;
  }

  return (
    <>
      <main className="content page_eco_mileage">
        <section className="section section_mileage_consent">
          <div
            className="mileage_consent_detail"
            dangerouslySetInnerHTML={{
              __html: terms.content,
            }}
          ></div>
        </section>
      </main>

      <div className="floating_action_area">
        <button
          type="button"
          className="btn btn_large btn_filled btn_full"
          onClick={() => backOrClose()}
        >
          {t('T10114')}
        </button>
      </div>
    </>
  );
}

export function Loading() {
  const {t} = useInferableTranslation();
  return (
    <>
      <main className="content page_eco_mileage">
        <section className="section section_mileage_consent">
          <div className="section_heading skeleton">
            <h2 className="section_heading_title skeleton">{t('T10114')}</h2>
          </div>
          <div
            className="mileage_consent_detail skeleton"
            style={{height: '200px'}}
          ></div>
        </section>
      </main>

      <div className="floating_action_area">
        <button
          type="button"
          className="btn btn_large btn_filled btn_full"
          disabled
        >
          {t('T10114')}
        </button>
      </div>
    </>
  );
}

export default CapitalTermsDetail;
